import NotificacaoGeralService from '../../services/NotificacaoGeralService'
import router from '../../router'

const state = () => ({
    loadingNotificacoes: false,
    notificacao: null,
    notificacoes: [],
    total: 0,
    pages: 0,
    page: 1
})
  
const mutations = {
    SET_NOTIFICACAO: (state, payload) => {
        state.notificacao = payload
    },
    SET_NOTIFICACOES: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.notificacoes = payload.itens
        }else{
            state.notificacoes = [...state.notificacoes, ...payload.itens]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total
    },
    SET_LOADING_NOTIFICACOES: (state, payload) => {
        state.loadingNotificacoes = payload
    },
}

const actions = {
    async fetchNotificacao({commit}, id){
        try{
            commit('SET_LOADING_NOTIFICACOES', true)
            const response = await NotificacaoGeralService.getOne(id);
            var dataNotificacao = response.data.item;
            if(dataNotificacao){
                if(dataNotificacao.data_inicio){
                    dataNotificacao.data_inicio = await formatarData(dataNotificacao.data_inicio);
                }
                if(dataNotificacao.data_fim){
                    dataNotificacao.data_fim = await formatarData(dataNotificacao.data_fim);
                }
            }
            commit('SET_NOTIFICACAO', dataNotificacao)
            commit('SET_LOADING_NOTIFICACOES', false)
        } catch (error) {
            commit('SET_LOADING_NOTIFICACOES', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchNotificacoes({commit}, { keyword = '', pageNumber = 1, sortBy = 'mais recentes' }){
        try{
            commit('SET_LOADING_NOTIFICACOES', true)
            const response = await NotificacaoGeralService.get(keyword, pageNumber, sortBy);
            commit('SET_NOTIFICACOES', response.data)
            commit('SET_LOADING_NOTIFICACOES', false)
        } catch (error) {
            commit('SET_LOADING_NOTIFICACOES', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async createNotificacao({commit}, data){
        try{
            commit('SET_LOADING_NOTIFICACOES', true)
            const response = await NotificacaoGeralService.create(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            router.push({path: `/form_notificacao_geral/${response.data.item.id}`});
            commit('SET_LOADING_NOTIFICACOES', false)
        } catch (error) {
            commit('SET_LOADING_NOTIFICACOES', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updateNotificacao({commit}, data){
        try{
            commit('SET_LOADING_NOTIFICACOES', true)
            const response = await NotificacaoGeralService.update(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_NOTIFICACOES', false)
        } catch (error) {
            commit('SET_LOADING_NOTIFICACOES', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async deleteNotificacao({state, commit}, id) {
        try{
            commit('SET_LOADING_NOTIFICACOES', true);
            if(state.notificacao.id == id){
                const response = await NotificacaoGeralService.delete(id);
                router.push({path: `/notificacoes-gerais`});
                commit('SET_ALERT', {
                    heading: 'success',
                    message: response.data.message
                });
            }
            commit('SET_SHOW_MODAL_CONFIRMATION', false);
            commit('SET_LOADING_NOTIFICACOES', false);
        } catch (error) {
            commit('SET_LOADING_NOTIFICACOES', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    }
}

async function formatarData(data) {
    const dataObj = new Date(data);
    const ano = dataObj.getUTCFullYear();
    const mes = (dataObj.getUTCMonth() + 1).toString().padStart(2, '0');
    const dia = dataObj.getUTCDate().toString().padStart(2, '0');
    const hora = dataObj.getUTCHours().toString().padStart(2, '0');
    const minuto = dataObj.getUTCMinutes().toString().padStart(2, '0');

    return `${ano}-${mes}-${dia}T${hora}:${minuto}`;
}

const getters = {
    getNotificacao: state => state.notificacao,
    getNotificacoes: state => state.notificacoes,
    getLoadingNotificacoes: state => state.loadingNotificacoes
}

export default {
    state,
    getters,
    mutations,
    actions
};